import React, { useEffect, useState } from "react";
import { RelayActionConfiguration } from "./RelayConfiguration.jsx";
import { useDispatch, useSelector } from "react-redux";
import update from "immutability-helper";
import { Button } from "bootstrap-micro";
import { relayActionDelete, relayActionSave } from "../store/relaysSlice.js";
import { selectSiteNameMap } from "../store/sitesSlice.js";

/*

export default connect(() => ({
    panelNameMap: ,
}), {
    saveRelayAction: saveRelayAction,
    deleteRelayAction: deleteRelayAction
})(RelayActionEditor)

*/


export const RelayActionEditor = props => {

    const dispatch = useDispatch();

    const [isDirty, setDirty] = useState(false);
    const [action, setAction] = useState(props.action);

    const panelNameMap = useSelector(selectSiteNameMap)

    useEffect(() => {
        if(!isDirty){
            setAction(props.action);
        }
    }, [props.action, isDirty]);

    return (
        <div className=" col-md-10 col-md-offset-1">
            <div className="panel panel-default">
                <div className="panel-heading">{panelNameMap[action.hwaddr]} ({action.hwaddr.replace(/([0-9a-f]{2})(?!$)/g, "$1:")})</div>

                <div className="panel-body" style={{ "paddingLeft": "5px" }}>
                    <h4>On Fire Event:</h4>
                    <RelayActionConfiguration
                        value={action.on_fire}
                        onChange={
                            cfg => {
                                setDirty(true);
                                setAction(update(action, { on_fire: { $set: cfg } }));
                            }
                        } 
                    />
                    <h4 style={{ clear: "both" }}>On Fault Event:</h4>
                    <RelayActionConfiguration
                        value={action.on_fault}
                        onChange={
                            cfg => {
                                setDirty(true);
                                setAction(update(action, { on_fault: { $set: cfg } }));
                            }
                        }
                    />
                    <div style={{ clear: "both" }}></div>
                    <Button disabled={!isDirty} bsStyle="primary" onClick={() => {
                        dispatch(relayActionSave(props.relayId, action)).then(() => {
                            setDirty(false);
                        })
                    }}>Save</Button>

                    <Button style={{ float: "right" }} bsStyle="danger" onClick={() => {
                        /* eslint-disable-next-line no-alert */
                        if (confirm("Delete this action?")) {
                            if(action.id){
                                dispatch(relayActionDelete(props.relayId, action));
                            }else{
                                props.onNewRemove();
                            }
                        }
                    }}>Delete</Button>
                </div>
            </div>
        </div>
    );
}

